module.exports = __webpack_public_path__ + "img/Refresh.e79402c9.svg";